import AddRubricModal from './AddRubricModal';

export default AddRubricModal;
